module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst additionalAttributes = []\nconst additionalClasses = []\nconst renderMode = ((storage || {}).request || {}).renderMode || ''\n// const meta = (model.tripData || {}).meta || {}\nconst tripAttributes = model.tripAttributes || {}\nconst tripReplacements = model.tripReplacements || {}\n// const document = meta.document || {}\nconst tripTimeRange       = tripReplacements.reisezeitraum\n// let tripTimeRange       = utils.moment(tripAttributes.tripStart).format('DD.MM.YYYY')\nlet tripTimeWeekOfYear  = utils.moment(tripAttributes.tripStart).format('W')\nif(tripAttributes.tripStart && tripAttributes.tripStart !== tripAttributes.tripEnd){\nif (tripAttributes.tripEnd) {\n// tripTimeRange       = `${tripTimeRange} - ${utils.moment(tripAttributes.tripEnd).format('DD.MM.YYYY')}`\nlet tripEndWoY = utils.moment(tripAttributes.tripEnd).format('W')\nif (tripTimeWeekOfYear !== tripEndWoY) {\ntripTimeWeekOfYear  = `${tripTimeWeekOfYear} - ${tripEndWoY}`\n}\n}\n}\nlet targetAddress = ''\nconst targetAddressParts = []\ntargetAddressParts.push(String(tripAttributes.clientAddress || '').replace(/\\n+/g, '<br>'))\ntargetAddress = targetAddressParts.join('<br>')\nif(renderMode === 'html'){\nadditionalClasses.push('styleTableWithoutBackground')\n}\nif(additionalClasses.length > 0){\nadditionalAttributes.push(`class=\"${additionalClasses.join(' ')}\"`)\n}\n%><div <%- additionalAttributes.join(' ') %>>\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n<section class=\"sheet\">\n<%- include('./header', { model }) %>\n<section class=\"body\">\n<div class=\"general\">\n<table class=\"drive-order-table\">\n<tbody>\n<tr class=\"titleRow\">\n<td class=\"title\"><%= storage.__('document.driveOrder.head') %></td>\n<td class=\"title-info\">(bitte 10 Tage vor Start der Fahrt/Reise an Schlager-Reisen zurücksenden)<br><strong>NOTRUFNUMMER: +43 676 770 38 10</strong></td>\n</tr>\n<tr>\n<td colspan=\"2\" style=\"padding: 0\">\n<br>\n<table class=\"bus\">\n<tbody>\n<tr>\n<td class=\"t\"><strong>Busfahrer:</strong><br>(Name, Nr, Std.)</td>\n<td class=\"c\" colspan=\"5\"><%= tripAttributes.drivers %></td>\n</tr>\n<tr><td colspan=\"6\" class=\"spacer\"></td></tr>\n<tr>\n<td class=\"t\" width=\"22%\"><strong>Bus / Fahrzeug:</strong></td>\n<td class=\"c\" width=\"29%\"><%= tripAttributes.vessels %></td>\n<td class=\"t\" width=\"11%\"><strong class=\"ts\">Radan-<br>hänger:</strong></td>\n<td class=\"c\" ><%= tripAttributes.driveOrderBicycleTrailer %></td>\n<td class=\"t\" width=\"11%\"><strong class=\"ts\">Skibox:</strong></td>\n<td class=\"c\" width=\"16%\"><%= tripAttributes.driveOrderSkiBox %></td>\n</tr>\n</tbody>\n</table>\n<br>\n<table class=\"drive-order-locations\">\n<tbody>\n<tr>\n<td><strong>Datum + Wochentag(e):</strong></td>\n<td colspan=\"2\"><table class=\"date-information\">\n<tr>\n<td width=\"80%\"><%- tripTimeRange %></td>\n<td width=\"20%\" class=\"week\"><strong>KW <%= tripTimeWeekOfYear %></strong></td>\n</tr>\n</table></td>\n</tr>\n<tr>\n<td><strong>Auftraggeber:</strong><br>Firma / Verein, Reisebegleitung, Vor- & Nachname, Handynummer</td>\n<td colspan=\"2\"><table class=\"client-information\">\n<tr>\n<td width=\"60%\"><%- targetAddress %></td>\n<td width=\"40%\"><%\nif (tripAttributes.clientPhone) { %><strong>Telefon:</strong><br><%= tripAttributes.clientPhone %><% }\nif (tripAttributes.clientEmail) { %><br><strong>E-Mail:</strong><br><%= tripAttributes.clientEmail %><% }\n%></td>\n</tr>\n</table></td>\n</tr>\n<!--                                    <tr>-->\n<!--                                        <td class=\"travel-plan-info\" colspan=\"3\"><strong>Reiseziel:</strong><br>Programmablauf (bei Mehrtagesfahrten in einzelne Tage aufgeteilt), Adressen (Restaurants, Gasthäuser, Hotels, Museen, Parkplätze für den Bus, ...), Telefonnummern, Kontaktpersonen, Anmerkungen, Uhrzeiten (Abfahrts-, Weiterfahrts- und Ankunftszeiten, Anweisungen für den Busfahrer, ...</td>-->\n<!--                                    </tr>-->\n<% for (const s of tripAttributes.tripStages || []) { %>\n<tr>\n<td><strong><%= s.stage %>:</strong></td><%\nif(s.driveOrderNotice) {\n%><td style=\"width: unset;\"><%- s.title %></td><%\n%><td style=\"width: unset; text-align: right; font-style: italic;\"><%- s.driveOrderNotice %></td><%\n} else {\n%><td colspan=\"2\"><%- s.title %></td><%\n}\n%>\n</tr>\n<% } %>\n<tr>\n<td><strong>Personenanzahl:</strong></td>\n<td colspan=\"2\"><%- tripAttributes.numberOfPersons || '-' %></td>\n</tr>\n<%\nif(\ntripAttributes.driveOrderOptionsEZ ||\ntripAttributes.driveOrderOptionsDZ ||\ntripAttributes.driveOrderOptions3BZ ||\ntripAttributes.driveOrderOptionsHP ||\ntripAttributes.driveOrderOptionsVP\n){\n%>\n<tr>\n<td class=\"room-title\"><strong>Zimmer:</strong><br>Falls die Reservierung über Schlager-Reisen läuft, HP?</td>\n<td style=\"padding: 0\" colspan=\"2\"><table class=\"rooms\">\n<tr>\n<td width=\"25%\"><strong>EZ</strong></td>\n<td width=\"25%\"><strong>DZ</strong></td>\n<td width=\"25%\"><strong>3BZ</strong></td>\n<td width=\"25%\"><strong>HP/VP</strong></td>\n</tr>\n<tr>\n<td><%= tripAttributes.driveOrderOptionsEZ %></td>\n<td><%= tripAttributes.driveOrderOptionsDZ %></td>\n<td><%= tripAttributes.driveOrderOptions3BZ %></td>\n<td><%= tripAttributes.driveOrderOptionsHP %>/<%= tripAttributes.driveOrderOptionsVP %></td>\n</tr>\n</table></td>\n</tr>\n<%\n}\n%>\n</tbody>\n</table>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n<% if(tripAttributes.status === 'canceled'){ %>\n<div class=\"watermark\">\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"500\" height=\"160\" viewBox=\"0 0 500 160\"><path d=\"M478.5,148.14H24.78c-.94,0-1.88,0-2.82,0-.14,0-.28,0-.42,0a10.28,10.28,0,0,1-7.81-3.9c-2.09-2.93-2-5-2-8.65V85.92c0-21.28-.16-42.57,0-63.85a10,10,0,0,1,9.77-10.2H453c8.38,0,16.76-.06,25.14,0a9.84,9.84,0,0,1,8.72,4.7,9.39,9.39,0,0,1,1.44,5.5V131c0,2.33,0,4.65,0,7a10,10,0,0,1-9.77,10.2c-7.53.17-7.55,12,0,11.85A21.93,21.93,0,0,0,500,138.26c0-1.83,0-3.66,0-5.49V25.29c0-3.28.07-6.54-.89-9.74A21.87,21.87,0,0,0,478.45,0c-2.15,0-4.3,0-6.44,0H22.79c-.87,0-1.73,0-2.6.05A21.93,21.93,0,0,0,.05,21.77c-.12,6.62,0,13.25,0,19.87V134.9c0,3.44,0,6.86,1.09,10.19A21.88,21.88,0,0,0,21.6,160c.66,0,1.32,0,2,0H478.5C486,160,486.06,148.14,478.5,148.14Z\" style=\"fill:#c1272d\"/><text style=\"font-size:80px;fill:#c1272d;font-family:OpenSans-Bold, Open Sans;font-weight:700;\" dy=\"28\" x=\"50%\" y=\"50%\" text-anchor=\"middle\">Storno</text></svg>\n</div>\n<% } %>\n<%- helpers.renderSection('content') %>\n</section>\n<!--<section class=\"footer driveOrderFooter\" style=\"width: 100%; text-align: right; padding-right: 68px; font-size: 10px; line-height: 1.5; font-family: 'Roboto Condensed', sans-serif, Arial; color: #AAAAAA;\"><%\n%><span class=\"pageNumber\"></span> / <span class=\"totalPages\"></span><%\n%></section>-->\n<section class=\"footer\" style=\"width: 100%; height: 0px;\">&nbsp;</section>\n</section>\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n</div>"
  , __filename = "components/templates/core/documents/driveOrder/driveOrder.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const additionalAttributes = []
const additionalClasses = []
const renderMode = ((storage || {}).request || {}).renderMode || ''
// const meta = (model.tripData || {}).meta || {}
const tripAttributes = model.tripAttributes || {}
const tripReplacements = model.tripReplacements || {}
// const document = meta.document || {}
const tripTimeRange       = tripReplacements.reisezeitraum
// let tripTimeRange       = utils.moment(tripAttributes.tripStart).format('DD.MM.YYYY')
let tripTimeWeekOfYear  = utils.moment(tripAttributes.tripStart).format('W')
if(tripAttributes.tripStart && tripAttributes.tripStart !== tripAttributes.tripEnd){
if (tripAttributes.tripEnd) {
// tripTimeRange       = `${tripTimeRange} - ${utils.moment(tripAttributes.tripEnd).format('DD.MM.YYYY')}`
let tripEndWoY = utils.moment(tripAttributes.tripEnd).format('W')
if (tripTimeWeekOfYear !== tripEndWoY) {
tripTimeWeekOfYear  = `${tripTimeWeekOfYear} - ${tripEndWoY}`
}
}
}
let targetAddress = ''
const targetAddressParts = []
targetAddressParts.push(String(tripAttributes.clientAddress || '').replace(/\n+/g, '<br>'))
targetAddress = targetAddressParts.join('<br>')
if(renderMode === 'html'){
additionalClasses.push('styleTableWithoutBackground')
}
if(additionalClasses.length > 0){
additionalAttributes.push(`class="${additionalClasses.join(' ')}"`)
}

    ; __line = 31
    ; __append("<div ")
    ; __append( additionalAttributes.join(' ') )
    ; __append(">\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n<section class=\"sheet\">\n")
    ; __line = 36
    ; __append( include('./header', { model }) )
    ; __append("\n<section class=\"body\">\n<div class=\"general\">\n<table class=\"drive-order-table\">\n<tbody>\n<tr class=\"titleRow\">\n<td class=\"title\">")
    ; __line = 42
    ; __append(escapeFn( storage.__('document.driveOrder.head') ))
    ; __append("</td>\n<td class=\"title-info\">(bitte 10 Tage vor Start der Fahrt/Reise an Schlager-Reisen zurücksenden)<br><strong>NOTRUFNUMMER: +43 676 770 38 10</strong></td>\n</tr>\n<tr>\n<td colspan=\"2\" style=\"padding: 0\">\n<br>\n<table class=\"bus\">\n<tbody>\n<tr>\n<td class=\"t\"><strong>Busfahrer:</strong><br>(Name, Nr, Std.)</td>\n<td class=\"c\" colspan=\"5\">")
    ; __line = 52
    ; __append(escapeFn( tripAttributes.drivers ))
    ; __append("</td>\n</tr>\n<tr><td colspan=\"6\" class=\"spacer\"></td></tr>\n<tr>\n<td class=\"t\" width=\"22%\"><strong>Bus / Fahrzeug:</strong></td>\n<td class=\"c\" width=\"29%\">")
    ; __line = 57
    ; __append(escapeFn( tripAttributes.vessels ))
    ; __append("</td>\n<td class=\"t\" width=\"11%\"><strong class=\"ts\">Radan-<br>hänger:</strong></td>\n<td class=\"c\" >")
    ; __line = 59
    ; __append(escapeFn( tripAttributes.driveOrderBicycleTrailer ))
    ; __append("</td>\n<td class=\"t\" width=\"11%\"><strong class=\"ts\">Skibox:</strong></td>\n<td class=\"c\" width=\"16%\">")
    ; __line = 61
    ; __append(escapeFn( tripAttributes.driveOrderSkiBox ))
    ; __append("</td>\n</tr>\n</tbody>\n</table>\n<br>\n<table class=\"drive-order-locations\">\n<tbody>\n<tr>\n<td><strong>Datum + Wochentag(e):</strong></td>\n<td colspan=\"2\"><table class=\"date-information\">\n<tr>\n<td width=\"80%\">")
    ; __line = 72
    ; __append( tripTimeRange )
    ; __append("</td>\n<td width=\"20%\" class=\"week\"><strong>KW ")
    ; __line = 73
    ; __append(escapeFn( tripTimeWeekOfYear ))
    ; __append("</strong></td>\n</tr>\n</table></td>\n</tr>\n<tr>\n<td><strong>Auftraggeber:</strong><br>Firma / Verein, Reisebegleitung, Vor- & Nachname, Handynummer</td>\n<td colspan=\"2\"><table class=\"client-information\">\n<tr>\n<td width=\"60%\">")
    ; __line = 81
    ; __append( targetAddress )
    ; __append("</td>\n<td width=\"40%\">")
    ; __line = 82
    ; 
if (tripAttributes.clientPhone) { 
    ; __line = 83
    ; __append("<strong>Telefon:</strong><br>")
    ; __append(escapeFn( tripAttributes.clientPhone ))
    ;  }
if (tripAttributes.clientEmail) { 
    ; __line = 84
    ; __append("<br><strong>E-Mail:</strong><br>")
    ; __append(escapeFn( tripAttributes.clientEmail ))
    ;  }

    ; __line = 85
    ; __append("</td>\n</tr>\n</table></td>\n</tr>\n<!--                                    <tr>-->\n<!--                                        <td class=\"travel-plan-info\" colspan=\"3\"><strong>Reiseziel:</strong><br>Programmablauf (bei Mehrtagesfahrten in einzelne Tage aufgeteilt), Adressen (Restaurants, Gasthäuser, Hotels, Museen, Parkplätze für den Bus, ...), Telefonnummern, Kontaktpersonen, Anmerkungen, Uhrzeiten (Abfahrts-, Weiterfahrts- und Ankunftszeiten, Anweisungen für den Busfahrer, ...</td>-->\n<!--                                    </tr>-->\n")
    ; __line = 92
    ;  for (const s of tripAttributes.tripStages || []) { 
    ; __append("\n<tr>\n<td><strong>")
    ; __line = 94
    ; __append(escapeFn( s.stage ))
    ; __append(":</strong></td>")
    ; 
if(s.driveOrderNotice) {

    ; __line = 96
    ; __append("<td style=\"width: unset;\">")
    ; __append( s.title )
    ; __append("</td>")
    ; 

    ; __line = 97
    ; __append("<td style=\"width: unset; text-align: right; font-style: italic;\">")
    ; __append( s.driveOrderNotice )
    ; __append("</td>")
    ; 
} else {

    ; __line = 99
    ; __append("<td colspan=\"2\">")
    ; __append( s.title )
    ; __append("</td>")
    ; 
}

    ; __line = 101
    ; __append("\n</tr>\n")
    ; __line = 103
    ;  } 
    ; __append("\n<tr>\n<td><strong>Personenanzahl:</strong></td>\n<td colspan=\"2\">")
    ; __line = 106
    ; __append( tripAttributes.numberOfPersons || '-' )
    ; __append("</td>\n</tr>\n")
    ; __line = 108
    ; 
if(
tripAttributes.driveOrderOptionsEZ ||
tripAttributes.driveOrderOptionsDZ ||
tripAttributes.driveOrderOptions3BZ ||
tripAttributes.driveOrderOptionsHP ||
tripAttributes.driveOrderOptionsVP
){

    ; __line = 116
    ; __append("\n<tr>\n<td class=\"room-title\"><strong>Zimmer:</strong><br>Falls die Reservierung über Schlager-Reisen läuft, HP?</td>\n<td style=\"padding: 0\" colspan=\"2\"><table class=\"rooms\">\n<tr>\n<td width=\"25%\"><strong>EZ</strong></td>\n<td width=\"25%\"><strong>DZ</strong></td>\n<td width=\"25%\"><strong>3BZ</strong></td>\n<td width=\"25%\"><strong>HP/VP</strong></td>\n</tr>\n<tr>\n<td>")
    ; __line = 127
    ; __append(escapeFn( tripAttributes.driveOrderOptionsEZ ))
    ; __append("</td>\n<td>")
    ; __line = 128
    ; __append(escapeFn( tripAttributes.driveOrderOptionsDZ ))
    ; __append("</td>\n<td>")
    ; __line = 129
    ; __append(escapeFn( tripAttributes.driveOrderOptions3BZ ))
    ; __append("</td>\n<td>")
    ; __line = 130
    ; __append(escapeFn( tripAttributes.driveOrderOptionsHP ))
    ; __append("/")
    ; __append(escapeFn( tripAttributes.driveOrderOptionsVP ))
    ; __append("</td>\n</tr>\n</table></td>\n</tr>\n")
    ; __line = 134
    ; 
}

    ; __line = 136
    ; __append("\n</tbody>\n</table>\n</td>\n</tr>\n</tbody>\n</table>\n</div>\n")
    ; __line = 144
    ;  if(tripAttributes.status === 'canceled'){ 
    ; __append("\n<div class=\"watermark\">\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"500\" height=\"160\" viewBox=\"0 0 500 160\"><path d=\"M478.5,148.14H24.78c-.94,0-1.88,0-2.82,0-.14,0-.28,0-.42,0a10.28,10.28,0,0,1-7.81-3.9c-2.09-2.93-2-5-2-8.65V85.92c0-21.28-.16-42.57,0-63.85a10,10,0,0,1,9.77-10.2H453c8.38,0,16.76-.06,25.14,0a9.84,9.84,0,0,1,8.72,4.7,9.39,9.39,0,0,1,1.44,5.5V131c0,2.33,0,4.65,0,7a10,10,0,0,1-9.77,10.2c-7.53.17-7.55,12,0,11.85A21.93,21.93,0,0,0,500,138.26c0-1.83,0-3.66,0-5.49V25.29c0-3.28.07-6.54-.89-9.74A21.87,21.87,0,0,0,478.45,0c-2.15,0-4.3,0-6.44,0H22.79c-.87,0-1.73,0-2.6.05A21.93,21.93,0,0,0,.05,21.77c-.12,6.62,0,13.25,0,19.87V134.9c0,3.44,0,6.86,1.09,10.19A21.88,21.88,0,0,0,21.6,160c.66,0,1.32,0,2,0H478.5C486,160,486.06,148.14,478.5,148.14Z\" style=\"fill:#c1272d\"/><text style=\"font-size:80px;fill:#c1272d;font-family:OpenSans-Bold, Open Sans;font-weight:700;\" dy=\"28\" x=\"50%\" y=\"50%\" text-anchor=\"middle\">Storno</text></svg>\n</div>\n")
    ; __line = 148
    ;  } 
    ; __append("\n")
    ; __line = 149
    ; __append( helpers.renderSection('content') )
    ; __append("\n</section>\n<!--<section class=\"footer driveOrderFooter\" style=\"width: 100%; text-align: right; padding-right: 68px; font-size: 10px; line-height: 1.5; font-family: 'Roboto Condensed', sans-serif, Arial; color: #AAAAAA;\">")
    ; __line = 151
    ; 

    ; __line = 152
    ; __append("<span class=\"pageNumber\"></span> / <span class=\"totalPages\"></span>")
    ; 

    ; __line = 153
    ; __append("</section>-->\n<section class=\"footer\" style=\"width: 100%; height: 0px;\">&nbsp;</section>\n</section>\n<section class=\"controls\">\n<!-- extra management control buttons may be needed in the future -->\n</section>\n</div>")
    ; __line = 159
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/documents/driveOrder/driveOrder.ejs

}